import {
  _getJobList,
  _getAccountList,
  _getUnitListForCreate,
  _createOrEditAccount,
  _stopOrReuseAccount,
  _unbindAcount,
  _deleteAccount,
  _confirmEnterpriseCustomer,
} from '@/api/Operation'
import {
  catchErr
} from '@/utils/utils'
import {
  Message
} from 'element-ui'

export default {
  // 获取列表
  async getTableList_A({
    commit,
    state
  }) {
    let searchData = state.searchData;
    let params = {
      roleId: state.activeTabId
    };
    if (searchData.dateRange != null && searchData.dateRange.length >= 2) {
      params.createDateStart = searchData.dateRange[0];
      params.createDateEnd = searchData.dateRange[1];
    }
    if (searchData.unitShortName != "") {
      params.unitShortName = searchData.unitShortName;
    }
    if (searchData.tel != "") {
      params.tel = searchData.tel;
    }
    if (searchData.state != "") {
      params.state = searchData.state;
    }
    if (searchData.enterpriseMobile != "") {
      params.enterpriseMobile = searchData.enterpriseMobile;
    }
    let pageData = state.pageData;

    let [err, res] = await catchErr(_getAccountList({
      data: params,
      pageInfo: pageData
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      if (res.data != undefined) {
        res.data.forEach((_t) => {
          if (_t.enterpriseMobile != undefined && _t.enterpriseMobile != '') {} else {
            _t.enterpriseMobile = '—'
          }
        });
      }
      let resData = res.data != undefined ? res.data : [];
      let resPage = res.pageInfo;
      commit("SETOPTIONS", {
        pageData: resPage,
        tableData: resData
      })

    }
    return;
  },
  // 获取全部岗位列表
  async getJobList_A({
    commit
  }) {
    let [err, res] = await catchErr(_getJobList());
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      let resData = res.data;
      resData.forEach(item => {
        item.id = item.id.toString()
      })

      commit("SETOPTIONS", {
        arrJobTypes: resData
      })
      if (resData.length > 0) {
        commit("SETOPTIONS", {
          activeTabId: resData[0].id,
          activeTabLabel: resData[0].name,
          activeType: resData[0].type
        })
      }
      return true;
    }
    return;
  },

  // 获取单位列表（创建帐号）
  async getUnitListForCreate_A({
    commit,
    state
  }) {
    let id = state.activeTabId;
    let [err, res] = await catchErr(_getUnitListForCreate({
      data: id
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      let resData = res.data;
      resData.forEach(item => {
        item.appId = item.appId.toString()
      })
      commit("SETOPTIONS", {
        arrUnitForCreate: resData
      })
    }
    return;
  },
  // 创建或编辑帐号

  async createOrEditAccount_A({}, params) {
    let [err, res] = await catchErr(_createOrEditAccount({
      data: params
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      if (res.status == 1000) {
        return true
      } else if (res.status == 1045) {
        Message.error("联系方式重复");
      } else if (res.status == 1009) {
        Message.error("单位下使用者名称重复");
      } else if (res.status == 1094) {
        Message.error("企业微信号已存在");
      } else if (res.status == 1095) {
        Message.error("请输入有效的企业微信号");
      } else {
        Message.error(res.message || '系统异常');
      }

    }
    return;
  },

  // 启用或停用帐号
  async stopOrReuseAccount_A({}, id) {
    let [err, res] = await catchErr(_stopOrReuseAccount({
      data: id
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      if (res.status == 1000) {
        return true
      } else if (res.status == 1049) {
        Message.error("帐号已预约告别厅");
      } else {
        Message.error(res.message || '系统异常');
      }

    }
    return;
  },

  // 启用或停用帐号
  async unbindAcount_A({}, id) {
    let [err, res] = await catchErr(_unbindAcount({
      data: id
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      if (res.status == 1000) {
        return true
      } else {
        Message.error(res.message || '系统异常');
      }

    }
    return;
  },

  // 删除帐号
  async deleteAccount_A({}, id) {
    let [err, res] = await catchErr(_deleteAccount({
      data: id
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      if (res.status == 1000) {
        return true
      } else if (res.status == 1050) {
        Message.error("帐号启用不能删除");
      } else {
        Message.error(res.message || '系统异常');
      }

    }
    return;
  },

  //确认企业微信与客户关系
  async confirmEnterpriseCustomer({}, id) {
    let [err, res] = await catchErr(_confirmEnterpriseCustomer({
      data: id
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      if (res.status == 1000) {
        return true
      } else {
        Message.error(res.message || '系统异常');
      }

    }
    return;
  },

}



// WEBPACK FOOTER //
// ./src/store/modules/Operation/actions.js